import { render, staticRenderFns } from "./PauseConfirmation.vue?vue&type=template&id=67353442&"
import script from "./PauseConfirmation.vue?vue&type=script&lang=js&"
export * from "./PauseConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports